<template>
  <!-- 话务系统-客户信息 -->
  <div class="customer-info">
    <el-form ref="formRef" :model="customerInfo" label-width="100px">
      <el-row>
        <el-col span="8">
          <el-form-item
            label="客户姓名："
            prop="customerName"
            :rules="[{ required: true, message: '请输入客户姓名', trigger: 'blur' }]"
          >
            <el-input
              v-model="customerInfo.customerName"
              placeholder="请输入 客户姓名"
              maxlength="20"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="联系电话：" prop="customerTel">
            <el-input v-model="customerInfo.customerTel" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item
            label="客户性别："
            prop="customerGender"
            :rules="[{ required: true, message: '请选择客户性别', trigger: 'change' }]"
          >
            <el-select
              style="width: 100%"
              v-model="customerInfo.customerGender"
              placeholder="请选择 客户性别"
            >
              <el-option
                v-for="(item, index) in sexDictData"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item
            label="客户类型："
            prop="customerType"
            :rules="[{ required: true, message: '请选择客户类型', trigger: 'change' }]"
          >
            <el-select
              style="width: 100%"
              v-model="customerInfo.customerType"
              placeholder="请选择 客户类型"
            >
              <el-option
                v-for="(item, index) in customerDictData"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="证件类型：">
            <el-select
              style="width: 100%"
              v-model="customerInfo.customerCertificateType"
              placeholder="请选择 证件类型"
            >
              <el-option
                v-for="(item, index) in IDCTypeDictData"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="证件号：">
            <el-input
              v-model="customerInfo.customerCertificateNo"
              placeholder="请输入 证件号"
              maxlength="20"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="客户信息：">
            <avue-input-tree
              v-model="customerInfo.customerDeptId"
              placeholder="请选择 客户信息"
              style="width: 100%"
              :dic="deptData"
              :props="{
                children: 'children',
                label: 'title',
              }"
            ></avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item label="客户地址：">
            <el-input
              v-model="customerInfo.customerAddr"
              placeholder="请输入 客户地址"
              maxlength="20"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="8">
          <el-form-item
            label="服务类别："
            prop="serviceType"
            :rules="[{ required: true, message: '请选择服务类别', trigger: 'change' }]"
          >
            <el-select
              style="width: 100%"
              v-model="customerInfo.serviceType"
              placeholder="请选择 服务类别"
            >
              <el-option
                v-for="(item, index) in serviceDictType"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="24">
          <el-form-item label="内容记录：">
            <el-input
              v-model="customerInfo.description"
              type="textarea"
              :rows="2"
              maxlength="200"
              show-word-limit
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col span="24">
          <el-form-item>
            <div class="btn">
              <el-button type="primary" size="small" :disabled="!phoneNum" @click="doSave">
                保存信息
              </el-button>
              <el-button type="primary" size="small" :disabled="!phoneNum" @click="addOrder">
                新建工单
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <AddOrder ref="addOrder" @success="createOrderSuccess"></AddOrder>
  </div>
</template>

<script>
import AddOrder from '../components/add-order';
import { getDictApi, getDeptTreeApi } from '@/api/call-system/index';
import { getCustomerDetailApi, saveRecordApi } from '@/api/call-system/call-sidebar';

export default {
  name: 'CustomerInfo',
  props: {
    /* 客户号码 */
    phoneNum: {
      type: String,
    },
  },
  components: {
    AddOrder,
  },
  data() {
    return {
      customerInfo: {}, // 客户详情数据
      sexDictData: [], // 性别
      customerDictData: [], // 客户类型
      IDCTypeDictData: [], // 证件类型
      serviceDictType: [], // 服务类型
      deptData: [], // 部门数据
      orderNos: [], // 工单编号列表
    };
  },
  watch: {
    phoneNum: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCustomerInfo();
        }
      },
    },
  },
  created() {
    getDictApi({
      code: 'sex',
    }).then(({ data }) => {
      this.sexDictData = data;
    });
    getDictApi({
      code: 'telephone_customer_type',
    }).then(({ data }) => {
      this.customerDictData = data;
    });
    getDictApi({
      code: 'telephone_customer_certificate_type',
    }).then(({ data }) => {
      this.IDCTypeDictData = data;
    });
    getDictApi({
      code: 'call_service_type',
    }).then(({ data }) => {
      this.serviceDictType = data;
    });
    getDeptTreeApi().then(({ data }) => {
      this.deptData = data;
    });
  },
  methods: {
    getCustomerInfo() {
      this.orderNos = [];
      getCustomerDetailApi({
        phone: this.phoneNum,
      }).then(({ data }) => {
        if (JSON.stringify(data) == '{}') {
          this.customerInfo = {
            customerTel: this.phoneNum,
          };
        } else {
          this.customerInfo = data;
          if (!this.customerInfo.customerTel) {
            this.customerInfo.customerTel = this.phoneNum;
          }
        }
      });
    },
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.customerInfo.orderNo = this.orderNos.join(',');
          saveRecordApi(this.customerInfo, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('saveFinised');
          });
        }
      });
    },
    addOrder() {
      this.$refs.addOrder.showDialog(this.customerInfo);
    },
    createOrderSuccess(orderInfo) {
      // 这里保存的数据格式改成'code-projectId'，因为后续查详情必须配合项目id才行
      this.orderNos.push(orderInfo.code + '-' + orderInfo.projectId);
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-info {
  width: 100%;
}
</style>
